import React from "react";
import MessagesLayout from "../../components/messages/MessagesLayout";
import useMessagesData from "../../hooks/messages/useMessagesData";

export default function MessagesPage() {
  const data = useMessagesData();

  return (
    <main className="relative z-[1] w-full min-h-[calc(100vh-72px)] px-4 sm:px-6 py-5 sm:py-7">
      <div className="mx-auto flex h-[calc(100vh-118px)] min-h-0 max-h-[calc(100vh-118px)] w-full max-w-[1540px] flex-col overflow-hidden rounded-[30px] border border-white/10 bg-[#070a12]/88 shadow-[0_22px_80px_rgba(0,0,0,0.48)] backdrop-blur-xl">
        <MessagesLayout {...data} />
      </div>
    </main>
  );
}
